(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCategorySliders() {
    document.querySelectorAll('.category-slider-section').forEach(function (section) {
      if (section.dataset.categorySliderInit) return;
      section.dataset.categorySliderInit = 'true';

      var track = section.querySelector('[data-category-slider-track]');
      var prevBtn = section.querySelector('[data-category-slider-prev]');
      var nextBtn = section.querySelector('[data-category-slider-next]');
      if (!track) return;

      // Force the slider back to its starting position.
      // Browsers persist scrollLeft on internally-scrollable elements across
      // reloads and back/forward navigation — this overrides that.
      function resetToStart() {
        track.scrollLeft = 0;
        updateArrowState();
      }

      function scrollAmount() {
        var card = track.querySelector('.category-slide-card');
        if (!card) return track.clientWidth * 0.8;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0);
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrowState() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
        prevBtn.classList.toggle('is-disabled', prevBtn.disabled);
        nextBtn.classList.toggle('is-disabled', nextBtn.disabled);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateArrowState, 60);
      });

      window.addEventListener('resize', updateArrowState);

      // Reset on first load...
      resetToStart();

      // ...and again once images finish loading, since late image loads can
      // shift scrollWidth and confuse the arrow disabled-state.
      window.addEventListener('load', resetToStart);

      // ...and again if the page is restored from the back/forward cache,
      // which is when the "wrong starting position" is most noticeable.
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) resetToStart();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategorySliders);
  } else {
    initCategorySliders();
  }

  document.addEventListener('shopify:section:load', initCategorySliders);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reel-yak-audit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeAuditCarousels = (scope = document) => {
      scope.querySelectorAll('[data-reel-yak-audit]').forEach((section) => {
        if (section.dataset.carouselInitialized === 'true') return;

        const carousel = section.querySelector('[data-feature-carousel]');
        const slides = Array.from(section.querySelectorAll('[data-feature-slide]'));
        const dots = Array.from(section.querySelectorAll('[data-carousel-dot]'));

        if (!carousel || slides.length === 0 || dots.length !== slides.length) return;

        section.dataset.carouselInitialized = 'true';
        let activeIndex = 0;
        let frame = null;

        const setActive = (index) => {
          activeIndex = Math.max(0, Math.min(index, slides.length - 1));
          dots.forEach((dot, dotIndex) => {
            if (dotIndex === activeIndex) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        };

        const goTo = (index) => {
          const target = Math.max(0, Math.min(index, slides.length - 1));
          carousel.scrollTo({ left: slides[target].offsetLeft, behavior: 'smooth' });
          setActive(target);
        };

        dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

        carousel.addEventListener('scroll', () => {
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const nearest = slides.reduce((best, slide, index) => {
              return Math.abs(slide.offsetLeft - carousel.scrollLeft) < Math.abs(slides[best].offsetLeft - carousel.scrollLeft) ? index : best;
            }, 0);
            setActive(nearest);
          });
        }, { passive: true });

        carousel.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goTo(activeIndex + 1);
          }
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(activeIndex - 1);
          }
        });
      });
    };

    initializeAuditCarousels();
    document.addEventListener('shopify:section:load', (event) => initializeAuditCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
